<template>
	<div v-show="cashback > 0"
		class="flex items-center gap-2 bg-grey-1 border border-solid border-gold rounded text-gold py-3 px-2 mt-4">
		<div>
			<IconStarCashback />
		</div>

		<div>Instant RoG</div>

		<div class="grow text-right">{{ currencySymbol }} {{ cashbackShown }}</div>
	</div>
</template>

<script>
import { Decimal } from 'decimal.js'
import IconStarCashback from './icons/IconStarCashback.vue'

import utils from '../utils'

export default {
	name: 'Cashback',
	components: {
		IconStarCashback,
	},

	props: {
		contractValue: {
			type: Number | String,
			default: 0,
		},
	},

	data() {
		return {
			cashback: 0,
		}
	},

	computed: {
		currency() {
			return this.$store.state.currency
		},

		cashbackShown() {
			return utils.currencyFormat(String(this.cashback), 'idr')
		},

		decimalPlaces() {
			if (this.currency == 'idr') {
				return 0
			} else {
				return this.$store.state.fractionDigit[this.currency]
			}
		}
	},

	watch: {
		contractValue(newValue) {
			// 1% of contract value
			this.cashback = Decimal.mul(newValue, 0.01).toDecimalPlaces(this.decimalPlaces, Decimal.ROUND_DOWN).toFixed(this.$store.state.fractionDigit[this.currency])
		},

		currency(newValue) {
			this.cashback = Decimal.mul(this.contractValue, 0.01).toDecimalPlaces(this.decimalPlaces, Decimal.ROUND_DOWN).toFixed(this.$store.state.fractionDigit[newValue])
		},
	},

	mounted() {
		this.cashback = Decimal.mul(this.contractValue, 0.01).toDecimalPlaces(this.decimalPlaces, Decimal.ROUND_DOWN).toFixed(this.$store.state.fractionDigit[this.currency])
	},
}
</script>

<style></style>